"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montegranaro": {
    "5badc29c": [{
      "hkey": "efd016bc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "guazzetti": [{
      "hkey": "efd016bc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montegranaro"
    }],
    "32d48d82": [{
      "hkey": "e35eb35b",
      "slug": "montegranaro",
      "name": "Montegranaro",
      "primary": true,
      "skipSearch": false
    }],
    "san-liborio": [{
      "hkey": "e35eb35b",
      "slug": "montegranaro",
      "name": "Montegranaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5a5fb9fc": [{
      "hkey": "e35eb35b",
      "slug": "montegranaro",
      "name": "Montegranaro",
      "primary": true,
      "skipSearch": false
    }],
    "san-tommaso": [{
      "hkey": "e35eb35b",
      "slug": "montegranaro",
      "name": "Montegranaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9a1c00eb": [{
      "hkey": "e35eb35b",
      "slug": "montegranaro",
      "name": "Montegranaro",
      "primary": true,
      "skipSearch": false
    }],
    "santa-leandra": [{
      "hkey": "e35eb35b",
      "slug": "montegranaro",
      "name": "Montegranaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b5aef5aa": [{
      "hkey": "efd016bc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria": [{
      "hkey": "efd016bc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montegranaro"
    }],
    "9c8fdef3": [{
      "hkey": "e35eb35b",
      "slug": "montegranaro",
      "name": "Montegranaro",
      "primary": true,
      "skipSearch": false
    }],
    "vallone": [{
      "hkey": "e35eb35b",
      "slug": "montegranaro",
      "name": "Montegranaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3feaf982": [{
      "hkey": "9d17a8de",
      "slug": "villa-luciani",
      "name": "Villa Luciani",
      "primary": true,
      "skipSearch": false
    }],
    "villa-luciani-il-torrione": [{
      "hkey": "9d17a8de",
      "slug": "villa-luciani",
      "name": "Villa Luciani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;